import React from 'react';
import './uber2.css';
import { AREAS, AREAS_OBJ, AREA_IDS } from './model/areas';
import ApiController from './controller/ApiController';
import { FINALISTS, SHORTLIST } from './model/shortlist';

/**
 * @author Carl Trelfa
 */

const NOMINEES_PER_ROW = 4;
const NOMINEES_PER_ROW_1350 = 3;
const NOMINEES_PER_ROW_840 = 2;
const NOMINEES_PER_ROW_410 = 2;

const WINNER_ID = '30';
const INNOVATOR_WINNERS = [
    {
        id: '43',
        cat: 'Female Chef/Restaurateur of the Year',
        name:'Natalie Francis',
        img: 'female.jpg'
    }, 
    {
        id: '20',
        cat: 'Sustainable Restaurant of the Year',
        name: 'Aled Hill and Shaun Jones',
        img: 'sustainable.jpg'
    }, 
    {
        id: '57',
        cat: 'Health Focused Restaurant of the Year',
        name: 'Henri Salameh & Emile Salame',
        img: 'health.jpg'
    }, 
    {
        id: '42',
        cat: 'Community Impact Award Restaurant of the Year',
        name: 'Rashpal Singh',
        img: 'community.jpg'
    }
];

const USE_PLACE_HOLDER_DATA = true;

export default class WinnerPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nomineesPerRow: NOMINEES_PER_ROW,
            shortlistFetched: false,
            shortList: null,
            winner: null,
        }
    }

    componentDidMount() {      
        let perRow = this.workOutNomineesPerRow();
        if (this.state.nomineesPerRow !== perRow) {
            this.setState({nomineesPerRow: perRow});
        }

        if (!this.state.shortlistFetched) {
            this.fetchShortlist();
        }

        window.addEventListener('resize', this.resizeHandler);

        console.log('Shortlist: ', SHORTLIST);
    }

    resizeHandler = () => {
        let perRow = this.workOutNomineesPerRow();
        if (this.state.nomineesPerRow !== perRow) {
            this.setState({nomineesPerRow: perRow});
        }
    }

    fetchShortlist = () => { 
        if (!USE_PLACE_HOLDER_DATA) {
            ApiController.FetchRestaurants(this.parseRestaurantData);
        } else {
            this.parseRestaurantData({response: SHORTLIST});
        }
        // ApiController.FetchRestaurants(this.parseRestaurantData);
    }

    parseRestaurantData = (data) => {
        let finalists = [];
        let winner = null;
        for (let i = 0; i < FINALISTS.length; i++) {
            for (let j = 0; j < data.response.length; j++) {
                if (USE_PLACE_HOLDER_DATA ? (j + 1) == FINALISTS[i] : data.response[j].restaurant_id == FINALISTS[i]) {
                    let r = {
                        id: USE_PLACE_HOLDER_DATA ? j + 1 : data.response[j].restaurant_id,
                        name: USE_PLACE_HOLDER_DATA ? data.response[j].name : data.response[j].restaurant_name,
                        area: USE_PLACE_HOLDER_DATA ? data.response[j].area : data.response[j].region_id,
                        image: USE_PLACE_HOLDER_DATA ? data.response[j].image : data.response[j].region_id + '/' + data.response[j].restaurant_image,
                    }
                    // if (String(r.id) !== String(WINNER_ID)) {
                        finalists.push(r);
                    // } else {
                    if (String(r.id) === String(WINNER_ID)) {
                        winner = r;
                    }
                    /* for (let k = 0; k < INNOVATOR_WINNERS.length; k++) {
                        if (String(INNOVATOR_WINNERS[k].id) === String(r.id)) {
                            INNOVATOR_WINNERS[k].data = r;
                        }
                    } */
                    break;
                }
            }
        }

        for (let i = 0; i < INNOVATOR_WINNERS.length; i++) {
            for (let j = 0; j < data.response.length; j++) {
                if (USE_PLACE_HOLDER_DATA ? (j + 1) == INNOVATOR_WINNERS[i].id : data.response[j].restaurant_id == INNOVATOR_WINNERS[i].id) {
                    let r = {
                        id: USE_PLACE_HOLDER_DATA ? j + 1 : data.response[j].restaurant_id,
                        name: USE_PLACE_HOLDER_DATA ? data.response[j].name : data.response[j].restaurant_name,
                        area: USE_PLACE_HOLDER_DATA ? data.response[j].area : data.response[j].region_id,
                        image: USE_PLACE_HOLDER_DATA ? data.response[j].image : data.response[j].region_id + '/' + data.response[j].restaurant_image,
                    }
                    // if (String(r.id) !== String(WINNER_ID)) {
                        // finalists.push(r);
                    // } else {
                    // if (String(r.id) === String(WINNER_ID)) {
                        // winner = r;
                    // }
                    // for (let k = 0; k < INNOVATOR_WINNERS.length; k++) {
                        // if (String(INNOVATOR_WINNERS[k].id) === String(r.id)) {
                            INNOVATOR_WINNERS[i].data = r;
                        // }
                    // }
                    break;
                }
            }
        }

        console.log('Finalists: ', data, finalists, winner);

        this.setState({
            shortlistFetched: true,
            shortList: finalists,
            winner: winner,
        });
    }

    workOutNomineesPerRow = () => {
        let perRow = NOMINEES_PER_ROW;
        if (window.innerWidth < 410) {
            perRow = NOMINEES_PER_ROW_410;
        } else
        if (window.innerWidth < 840) {
            perRow = NOMINEES_PER_ROW_840;
        } else
        if (window.innerWidth < 1350) {
            perRow = NOMINEES_PER_ROW_1350;
        }
        return perRow;
    }

    render() {
        let finalistRows = [[]];
        if (this.state.shortlistFetched) {
            let row = 0;
            let inRowCount = 0;
            for (let i = 0; i < this.state.shortList.length; i++) {
                finalistRows[row].push(this.state.shortList[i]);
                inRowCount++;
                if (inRowCount === this.state.nomineesPerRow && i < this.state.shortList.length - 1) {
                    inRowCount = 0;
                    row++;
                    finalistRows.push([]);
                }
            }
            /* while(finalistRows[row].length < this.state.nomineesPerRow) {
                finalistRows[row].push({});
            } */
            if (finalistRows[row].length < this.state.nomineesPerRow) {
                finalistRows[row].push({});
                finalistRows[row].splice(0, 0, {});
            }
            console.log('Finalist Rows: ', finalistRows);
        }

        return (
            <div className="split-page-holder-vote">
                <div className="page-split-left-vote"><div className="left-content-holder-vote">

                    <div className='small-screen-content-holder'>
                        <div className="nom-header">
                            <img className="uber-eats-logo-vote" src='./uber-assets/UE_Logo_Horizontal_RGB_web_GreenBG.svg' />
                        </div>
                        <h2>Uber Eats presents<br/>The Restaurant of the Year</h2>
                        <h1>And the winner is...</h1>
                        {this.state.shortlistFetched &&
                            <p>Congratulations to {this.state.winner.name} which has been named the Uber Eats Restaurant of the Year and awarded £100,000.</p>
                        }
                    </div>
                {this.state.shortlistFetched &&
                <>
                    <hr />

                    <div className='small-screen-content-holder'>

                    <h1 className='black-heading'>{this.state.winner.name} <span className='white'>- {AREAS_OBJ[this.state.winner.area]}</span></h1>

                            <div className='winner-holder'>
                                {/* <div className='flex-grow'></div>
                                <div className='winner-pic-holder'>
                                    <div className='nominee-pic' style={{ backgroundImage: 'url(./uber-assets/restaurant_imgs/' + this.state.winner.image + ')', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}></div>
                                    <div className='winner-badge'></div>
                                </div> */}
                                {/* <div className='flex-grow'></div> */}
                                {/* <div className='arrow-holder'>
                                    <div className='flex-grow'></div>
                                    <div className='flex-shrink'>
                                        <img className='arrow-pic' src='./uber-assets/arrow.svg' />
                                    </div>
                                    <div className='flex-grow'></div>
                                </div> */}
                                    <div className='flex-grow'></div>
                                    <div className='award-pic-holder'>
                                        {/*<img className='award-pic' src='./uber-assets/placeholder.jpg' />*/}
                                        <img className='award-pic' src={'./roty.jpg'} />
                                        {/* <div className='winner-badge'></div> */}
                                    </div>
                                    <div className='flex-grow'></div>
                                {/* <div className='arrow-holder'>
                                    <div className='flex-grow'></div>
                                    <div className='flex-shrink'>
                                        <img className='arrow-pic arrow-right' src='./uber-assets/arrow.svg' />
                                    </div>
                                    <div className='flex-grow'></div>
                                </div> */}
                                {/* <div className='flex-grow'></div> */}
                                
                            </div>

                    <p>&nbsp;</p>

                    <h1>Winners of the Pioneer and Innovators Awards 2023</h1>

                    <div className='nominee-row-2'>
                        
                        <div className='nominee-holder-2'>
                            <div className='winner-holder-2'>
                                <div className='flex-rows'>
                                        <div className='award-pic-holder'>
                                            <img className='award-pic' src={INNOVATOR_WINNERS[0].img || './winner-placeholder.png'} />
                                            {/* <div className='winner-badge'></div> */}
                                        </div>
                                        <h1 className='win-h1'>{INNOVATOR_WINNERS[0].cat}</h1>
                                        <p className='area-small white'>{INNOVATOR_WINNERS[0].name} from {INNOVATOR_WINNERS[0].data.name}</p>
                                        <div className='nominee-name'>
                                            <p>{AREAS_OBJ[INNOVATOR_WINNERS[0].data.area]}</p>
                                        </div>
                                </div>

                            </div>
                        </div>

                        <div className='nominee-holder-2'>
                            <div className='winner-holder-2'>
                                <div className='flex-rows'>
                                        <div className='award-pic-holder'>
                                            <img className='award-pic' src={INNOVATOR_WINNERS[1].img || './winner-placeholder.png'} />
                                            {/* <div className='winner-badge'></div> */}
                                        </div>
                                        <h1 className='win-h1'>{INNOVATOR_WINNERS[1].cat}</h1>
                                        <p className='area-small white'>{INNOVATOR_WINNERS[1].name} from {INNOVATOR_WINNERS[1].data.name}</p>
                                        <div className='nominee-name'>
                                            <p>{AREAS_OBJ[INNOVATOR_WINNERS[1].data.area]}</p>
                                        </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div className='nominee-row-2'>
                        
                        <div className='nominee-holder-2'>
                            <div className='winner-holder-2'>
                                <div className='flex-rows'>
                                        <div className='award-pic-holder'>
                                            <img className='award-pic' src={INNOVATOR_WINNERS[2].img || './winner-placeholder.png'} />
                                            {/* <div className='winner-badge'></div> */}
                                        </div>
                                        <h1 className='win-h1'>{INNOVATOR_WINNERS[2].cat}</h1>
                                        <p className='area-small white'>{INNOVATOR_WINNERS[2].name} from {INNOVATOR_WINNERS[2].data.name}</p>
                                        <div className='nominee-name'>
                                            <p>{AREAS_OBJ[INNOVATOR_WINNERS[2].data.area]}</p>
                                        </div>
                                </div>

                            </div>
                        </div>

                        <div className='nominee-holder-2'>
                            <div className='winner-holder-2'>
                                <div className='flex-rows'>
                                        <div className='award-pic-holder'>
                                            <img className='award-pic' src={INNOVATOR_WINNERS[3].img || './winner-placeholder.png'} />
                                            {/* <div className='winner-badge'></div> */}
                                        </div>
                                        <h1 className='win-h1'>{INNOVATOR_WINNERS[3].cat}</h1>
                                        <p className='area-small white'>{INNOVATOR_WINNERS[3].name} from {INNOVATOR_WINNERS[3].data.name}</p>
                                        <div className='nominee-name'>
                                            <p>{AREAS_OBJ[INNOVATOR_WINNERS[3].data.area]}</p>
                                        </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <p>&nbsp;</p>

                    <h1>Congratulations to all of our finalists...</h1>

                    {
                        finalistRows.map(
                            (item, index) => {
                                return (
                                    <div className='nominee-row' key={'nr_' + index}>
                                        {
                                            item.map(
                                                (item2, index2) => {
                                                    console.log('RData: ', item2);
                                                    return (
                                                        <>
                                                            <div className='nominee-holder' key={'nr_' + index + 'nh_' + index2}>
                                                                <p className='area-small'>{AREAS_OBJ[item2.area]}</p>
                                                                {item2.name &&
                                                                    <>
                                                                        <div className='nominee-name'>
                                                                            <p dangerouslySetInnerHTML={{ __html: item2.name.split('(')[0] }}></p>
                                                                        </div>
                                                                        <div className='nominee-pic-holder'>
                                                                            <div className='nominee-pic' style={{ backgroundImage: 'url(' + (item2.image != '' ? ('./uber-assets/restaurant_imgs/' + item2.area + '/' + item2.image) : './restaurantPlaceholder.jpg') + ')', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>

                                                                            </div>
                                                                            {/* <div className='finalist-badge'></div> */}
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                            {
                                                                index2 < this.state.nomineesPerRow - 1 && <div className='nominee-spacer'></div>
                                                            }
                                                        </>
                                                    )
                                                }
                                            )
                                        }
                                    </div>
                                );
                            }
                        )
                    }

                    </div>
                </>
                }


                    <div className='shrink'>
                        <hr />
                        <div className='small-screen-content-holder'>
                            <p className="form-label">All submitted data will be treated in accordance with our <a href="https://uber.com/legal" target="_blank">Privacy Policy</a>.</p>
                            <p className="form-label">Restaurant of the Year 2023 <a href="https://www.dropbox.com/s/b3841vdz83yp5bs/T%26Cs%20-%20Awards.pdf?dl=0" target="_blank">Terms and Conditions</a>.</p>
                            <p>&nbsp;</p>
                            <p className="form-label">&#169; 2023 Uber Technologies Inc.</p>
                        </div>
                    </div>

                    </div></div>
                    
                {/* <div className="page-split-right-vote">
                </div> */}
            </div>
        );
                }

 }